<label *ngIf="label.length > 0">{{label}}</label>
<div class="flag-input" 
  [ngClass]="{invalid: invalid}" 
  [formGroup]="form">
  <div class="dropdown-button" (click)="isOpen = !isOpen">
    <img class="flag-size" style="height: 16px;" src="../../../../assets/svgs/{{selectedOption.icon}}.svg" alt="{{selectedOption.icon}}">
    <p class="dropdown-title">{{selectedOption.prefix}}</p>
    <div class="svg-div">
      <img src="../../../../assets/svgs/dropdown_arrow_ico.svg" [ngClass]="{'icon-revert': isOpen}" label="arrow-icon" alt="dropdown-arrow">
    </div>   
  </div>
  <input 
    placeholder="{{placeholder}}" 
    type="tel" 
    [maxlength]="selectedOption?.mask_length" 
    formControlName="phone" 
    (input)=changeMask()> 

  <div class="dropdown-box" *ngIf="isOpen">
    <div class="dropdown-item" *ngFor="let flag of flagOptions ; let i = index" (click)="setFlag(flag)">
      <img class="flag-size" style="height: 16px;" src="../../../../assets/svgs/{{flag.icon}}.svg" alt="{{flag.icon}}">
      <p class="item-label">{{flag.country}}: {{flag.prefix}}</p>
    </div>
  </div>
</div>